module.exports = __webpack_public_path__ + "static/media/004-gold-cup.7591f917.png";